<template>
  <el-dialog title="汇款底单详细信息" :visible.sync="dialogVisible" width="700px" @close="handleClose">
    <el-form ref="form" :model="rateForm" :rules="rules" class="baseInfoForm">
      <div class="rj-page-card">
        <div class="rj-page-card__content">
          <div class="rj-row">
            <div class="rj-col-2">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  汇款编号：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.telegraphicTransferNo }}
                </div>
              </div>
            </div>
            <div class="rj-col-2">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  汇入公司：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.importCompany }}
                </div>
              </div>
            </div>
            <div class="rj-col-2">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  币种：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.currencyName }}
                </div>
              </div>
            </div>
            <div class="rj-col-2">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  代理名称：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.orderUnit || '无' }}
                </div>
              </div>
            </div>
            <div class="rj-col-2">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  汇款日期：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.remittanceTime }}
                </div>
              </div>
            </div>
            <div class="rj-col-2">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  汇款金额：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.remittanceAmount }}
                </div>
              </div>
            </div>
            <div class="rj-col-2">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  汇入行：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.importBank }}
                </div>
              </div>
            </div>
            <div class="rj-col-2">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  汇入账户：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.importAccount }}
                </div>
              </div>
            </div>
            <div class="rj-col-2">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  实际付款人：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.drawee }}
                </div>
              </div>
            </div>
            <div class="rj-col-2">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  付款用途：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.strRemittanceScenario }}
                </div>
              </div>
            </div>
            <div class="rj-col-2">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  收款单号：
                </div>
                <div class="rj-baseinfo__item">
                  <el-input v-model="info.telegraphicTransferNum" @blur="handleBlur" />
                </div>
              </div>
            </div>
            <div class="rj-col-2">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  实际到款金额：
                </div>
                <div class="rj-baseinfo__item">
                  <span v-if="info.telegraphicTransferNum === ''">-</span>
                  <span v-else>
                    {{ info.actualRemittanceAmount }}
                  </span>
                </div>
              </div>
            </div>
            <div class="rj-col-2">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  是否委托付款：
                </div>
                <div class="rj-baseinfo__item">
                  <span v-if="info.entrustedFlg === 1">是</span>
                  <span v-if="info.entrustedFlg === 0">否</span>
                </div>
              </div>
            </div>
            <div class="rj-col-2">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  可用余额：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.availableAmount }}
                </div>
              </div>
            </div>
            <div class="rj-col-2">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  手续费：
                </div>
                <div class="rj-baseinfo__item">
                  <span v-if="info.telegraphicTransferNum === ''">-</span>
                  <span v-else-if="nums <= 50">{{ nums }}</span>
                  <span v-else-if="nums > 50" style="color: red;">{{ nums }}</span>
                </div>
              </div>
            </div>
            <!-- <div class="rj-col-2">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">&nbsp;</div>
                <div class="rj-baseinfo__item">&nbsp;</div>
              </div>
            </div> -->
            <div class="rj-col-2">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  是否跨币种：
                </div>
                <div class="rj-baseinfo__item">
                  <el-form-item prop="crossCurrencyFlag">
                    <el-select v-model="rateForm.crossCurrencyFlag" :disabled="!info.telegraphicTransferNum" placeholder="请选择是否跨币种">
                      <el-option
                        v-for="item in crossCurrencyOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                  </el-form-item>
                </div>
              </div>
            </div>
            <template v-if="rateForm.crossCurrencyFlag === '1' || rateForm.crossCurrencyFlag === 1">
              <div class="rj-col-2">
                <div class="rj-baseinfo">
                  <div class="rj-baseinfo__label">
                    汇率日期<span v-show="rateForm.exchangeRateRule === 'sameDayMiddleRate'" class="required">*</span>：
                  </div>
                  <div class="rj-baseinfo__item">
                    <el-form-item prop="exchangeRateDate">
                      <el-date-picker
                        v-model="rateForm.exchangeRateDate"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="年 / 月 / 日"
                      />
                    </el-form-item>
                  </div>
                </div>
              </div>
              <div class="rj-col-2">
                <div class="rj-baseinfo">
                  <div class="rj-baseinfo__label">
                    汇率取值规则<span class="required">*</span>：
                  </div>
                  <div class="rj-baseinfo__item">
                    <el-form-item prop="exchangeRateRule">
                      <el-select v-model="rateForm.exchangeRateRule" placeholder="请选择汇率取值规则">
                        <el-option
                          v-for="item in exchangeRateRuleOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        />
                      </el-select>
                    </el-form-item>
                  </div>
                </div>
              </div>
              <div class="rj-col-2">
                <div class="rj-baseinfo">
                  <div class="rj-baseinfo__label">
                    目标币种<span class="required">*</span>：
                  </div>
                  <div class="rj-baseinfo__item">
                    <el-form-item prop="targetCurrency">
                      <el-select v-model="rateForm.targetCurrency" placeholder="请选择目标币种" @change="handleTargetCurrencyChange">
                        <el-option
                          v-for="item in targetCurrencyList"
                          :key="item.currency"
                          :label="item.currency"
                          :value="item.currency"
                        />
                      </el-select>
                    </el-form-item>
                  </div>
                </div>
              </div>
              <div class="rj-col-2">
                <div class="rj-baseinfo">
                  <div class="rj-baseinfo__label">
                    本次应收金额<span class="required">*</span>：
                  </div>
                  <div class="rj-baseinfo__item">
                    <el-form-item prop="currentReceivableAmount">
                      <el-input-number v-model="rateForm.currentReceivableAmount" :min="0" :precision="2" />
                    </el-form-item>
                  </div>
                </div>
              </div>
              <div class="rj-col-2">
                <div class="rj-baseinfo">
                  <div class="rj-baseinfo__label">
                    汇率值<span class="required">*</span>：
                  </div>
                  <div class="rj-baseinfo__item">
                    <el-form-item prop="exchangeRate">
                      <el-input-number
                        v-model="rateForm.exchangeRate"
                        :disabled="rateForm.exchangeRateRule === 'sameDayMiddleRate'"
                        :precision="4"
                        :step="0.1"
                      />
                      <div v-show="needFluctuationCheck && fluctuationExceeded" class="exchange-rate-tip">
                        汇率相比波动超过5%，数仓汇率 {{ dataWarehouseExchangeRate }}
                      </div>
                    </el-form-item>
                  </div>
                </div>
              </div>
              <div class="rj-col-2">
                <div class="rj-baseinfo">
                  <div class="rj-baseinfo__label">
                    转换金额：
                  </div>
                  <div class="rj-baseinfo__item">
                    <el-form-item prop="convertedAmount">
                      <el-input
                        v-model="rateForm.convertedAmount"
                        disabled
                        placeholder="待系统取汇率后计算"
                      />
                    </el-form-item>
                  </div>
                </div>
              </div>
              <div :class="needFluctuationCheck && fluctuationExceeded ? 'mt-5 rj-col-1' : 'rj-col-1'">
                <div class="rj-baseinfo">
                  <div class="rj-baseinfo__label">
                    虚拟来款单备注：
                  </div>
                  <div class="rj-baseinfo__item">
                    <el-input v-model.trim="rateForm.erpVirtualReceiptRemark" type="textarea" :rows="1" placeholder="请输入备注" />
                  </div>
                </div>
              </div>
            </template>
            <div class="rj-col-2">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">&nbsp;</div>
                <div class="rj-baseinfo__item">&nbsp;</div>
              </div>
            </div>
            <!-- <div class="rj-col-1">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  关联合同：
                </div>
              </div>
            </div> -->
            <div class="rj-col-1 related-contract-title rj-row-title">关联合同</div>
            <div class="rj-col-1 related-contract-actions">
              <el-button type="primary" @click="contract()">
                添加
              </el-button>
              <span class="related-contract-tip">请按转账后余额分配</span>
            </div>
            <div>
              <el-table :data="info.telegraphicContractRelationList" border style="width: 100%">
                <el-table-column label="合同编码 *" align="left">
                  <template slot-scope="scope">
                    <el-form-item class="cotractNum_item" :error="getContractVerifyError(scope.$index)">
                      <el-input v-model="scope.row.cotractNum" placeholder="请输" @input="handleContractInput(scope.$index)" @blur="blursone(scope.$index)" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="拆分金额 *" align="left">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.splitAmount" placeholder="请输入拆分金额" oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}" />
                  </template>
                </el-table-column>
                <el-table-column label="付款类型 *" align="left">
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.remittanceType" placeholder="请选择">
                      <el-option label="现销付款/赊销预付款" :value="0" />
                      <el-option label="赊销回款" :value="1" />
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column label="台账" align="left">
                  <template slot-scope="scope">
                    <el-form-item>
                      <el-input v-model="scope.row.ledgerNumber" placeholder="请输入台账" maxlength="20" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="操作" align="left">
                  <template slot-scope="scope">
                    <span style="text-align: center;width: 100%;cursor: pointer;color: rgb(28, 154, 212);" @click="buttonyichu(scope.$index)">
                      <span>移除</span>
                    </span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="rj-col-2">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  备注：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.remark }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-form>
    <div>附件</div>
    <el-table :data="fileListBase" border style="width: 100%">
      <el-table-column prop="fileName" label="文件名称" align="left" fixed="left" />
      <el-table-column prop="createBy" label="上传人" align="left" />
      <el-table-column prop="createTime" label="上传时间" align="left" />
      <el-table-column label="操作" align="left" fixed="right">
        <template v-slot="{row}">
          <el-button type="text" @click="handleDownload(row)">
            下载
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <br>
    <div>电汇所指订单表</div>
    <br>
    <el-table :data="tableDataBase" border style="width: 100%">
      <el-table-column type="index" width="60" label="序号" align="left" fixed="left" />
      <el-table-column prop="contractNum" label="锐捷电子商务合同编号" align="left" />
      <el-table-column prop="orderNo" label="分配订单号" align="left" />
      <el-table-column prop="actualSettlementAmount" label="订单总金额" align="right" header-align="left" />
      <el-table-column prop="assignedAmount" label="本次分配金额" align="right" header-align="left" />
      <el-table-column prop="assignedDate" label="分配日期" align="left" />
    </el-table>
    <div v-if="tableDataBase && tableDataBase.length">
      金额小计：{{ info.amountSubtotal }}
    </div>
    <div class="footer-btn">
      <el-button type="default" @click="handleCancel">
        取消
      </el-button>
      <el-button type="primary" :loading="submitLoading" class="submit" @click="handleSubmit">
        提交
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import {
  verifyreceiptnumber,
  listWaterOrderAttachment,
  getAliOSSDownloadInfo,
  getCompanyAndBankByBusinessEntity,
  verifyContractNum,
  getOrderUnitAndCurrencyByContractNum,
  getCheckExchangeRateFluctuation,
  getExchangeRate,
  getTargetCurrency,
  addTelegraphicTransferInternationBusiness
} from '@/API/international.js';
import { downloadBlobFile } from '@/libs/util';
import { buildIntlTelegraphicTransferComplianceRequest, checkIntlExportCompliance } from '@/libs/exportCompliance';
import Big from 'big.js';

const createDefaultRateForm = () => ({
  bussinessEntity: '', // 业务实体
  crossCurrencyFlag: '0', // 是否跨币种
  exchangeRateRule: 'sameDayMiddleRate', // 汇率取值规则
  exchangeRateDate: '', // 汇率日期
  targetCurrency: '', // 目标币种
  targetCurrencyName: '', // 目标币种名称
  currentReceivableAmount: '', // 本次应收金额
  exchangeRate: '', // 汇率值
  convertedAmount: '', // 转换金额
  erpVirtualReceiptRemark: '', // ERP虚拟收款备注
  convertedServiceFee: '', // 转换后手续费 本次应收金额 - (实际到账金额 / 汇率).fixed(2)
  convertedActualRemittanceAmount: '', // 转换后实际到账金额 (实际到账金额 / 汇率).fixed(2)
  virtualBankAccount: '', // 虚拟银行账户
  virtualBankAccountName: '' // 虚拟银行账户名称
});

const createDefaultRelationItem = () => ({
  cotractNum: '',
  splitAmount: '',
  remittanceType: '',
  ledgerNumber: ''
});

const CONTRACT_VERIFY_STATUS = Object.freeze({
  INITIAL: '',
  SUCCESS: 'success',
  CUSTOMER_MISMATCH: 'customerMismatch',
  INVALID: 'invalid'
});

const createDefaultContractVerifyStatus = () => ({
  status: CONTRACT_VERIFY_STATUS.INITIAL,
  contractCustomerName: ''
});

export default {
  name: 'ReceiptRecording',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    rowId: {
      type: [String, Number],
      default: ''
    },
    iswei: {
      type: [String, Number],
      default: ''
    },
    token: {
      type: String,
      default: ''
    },
    downFileUrl: {
      type: String,
      default: ''
    }
  },
  data () {
    const validateExchangeRateDate = (rule, value, callback) => {
      const crossCurrencyFlag = this.rateForm.crossCurrencyFlag === '1';
      const requiresExchangeRateDate = this.rateForm.exchangeRateRule === 'sameDayMiddleRate';

      if (crossCurrencyFlag && requiresExchangeRateDate && !value) {
        callback(new Error('请选择汇率日期'));
        return;
      }

      callback();
    };

    // 验证目标币种
    const validateTargetCurrency = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请选择目标币种'));
        return;
      }

      if (this.info.currency && value === this.info.currency) {
        callback(new Error('交易币种和目标币种一致'));
        return;
      }

      callback();
    };

    const validateExchangeRate = (rule, value, callback) => {
      const crossCurrencyFlag = this.rateForm.crossCurrencyFlag === '1';

      if (!crossCurrencyFlag) {
        callback();
        return;
      }

      if (value === '' || value === null || value === undefined || Number(value) <= 0) {
        callback(new Error('请输入大于0的汇率值'));
        return;
      }

      callback();
    };

    return {
      info: {},
      receiptAccount: '', // 收款单账号
      receiptCurrency: '', // 收款单币种
      contractCurrency: '', // 合同币种
      contractVerifyStatusList: [],
      loadedRowId: '',
      nums: '',
      submitLoading: false,
      fluctuationExceeded: false,
      needFluctuationCheck: false,
      dataWarehouseExchangeRate: null,
      rateForm: createDefaultRateForm(),
      fileListBase: [],
      tableDataBase: [],
      manualRateSyncSource: '',
      manualRateAnchorField: '',
      crossCurrencyOptions: [
        { label: '是', value: '1' },
        { label: '否', value: '0' }
      ],
      targetCurrencyList: [],
      rules: {
        crossCurrencyFlag: [
          { required: true, message: '请选择是否跨币种', trigger: 'change' }
        ],
        exchangeRateDate: [
          { validator: validateExchangeRateDate, trigger: 'change' }
        ],
        exchangeRateRule: [
          { required: true, message: '请选择汇率取值规则', trigger: 'change' }
        ],
        targetCurrency: [
          { validator: validateTargetCurrency, trigger: 'change' }
        ],
        currentReceivableAmount: [
          { required: true, message: '请输入本次应收金额', trigger: 'blur' }
        ],
        exchangeRate: [
          { validator: validateExchangeRate, trigger: 'blur' }
        ]
      }
    };
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible;
      },
      set (value) {
        this.$emit('update:visible', value);
      }
    },
    exchangeRateRuleOptions: function () {
      let value = ['福建锐捷'];
      if (value.includes(this.rateForm.bussinessEntity)) {
        return [
          { label: '客户付款当日汇率中间价', value: 'sameDayMiddleRate' },
          { label: 'PO 约定汇率', value: 'poAgreedRate' }
        ];
      } else {
        return [
          { label: 'PO 约定汇率', value: 'poAgreedRate' },
          { label: '其他约定汇率', value: 'otherAgreedRate' }
        ];
      }
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler (value) {
        if (value && this.rowId) {
          this.tryLoadDetail();
        }
        if (!value) {
          this.resetLocalState();
        }
      }
    },
    rowId (value) {
      if (this.visible && value) {
        this.tryLoadDetail();
      }
    },
    'info.remittanceAmount' () {
      this.syncManualExchangeRateByAnchor();
    },
    'rateForm.crossCurrencyFlag' (value) {
      if (value === '1' || value === 1) {
        return;
      }

      this.rateForm.exchangeRateDate = '';
      this.rateForm.targetCurrency = '';
      this.rateForm.targetCurrencyName = '';
      this.rateForm.currentReceivableAmount = '';
      this.rateForm.exchangeRate = '';
      this.rateForm.convertedAmount = '';
      this.rateForm.convertedServiceFee = '';
      this.rateForm.convertedActualRemittanceAmount = '';
      this.rateForm.virtualBankAccount = '';
      this.rateForm.virtualBankAccountName = '';
      this.fluctuationExceeded = false;
      this.needFluctuationCheck = false;
      this.dataWarehouseExchangeRate = null;
      this.manualRateSyncSource = '';
      this.manualRateAnchorField = '';

      if (!this.$refs.form) {
        return;
      }

      this.$nextTick(() => {
        this.$refs.form.clearValidate('exchangeRateDate');
        this.$refs.form.clearValidate('targetCurrency');
        this.$refs.form.clearValidate('currentReceivableAmount');
        this.$refs.form.clearValidate('exchangeRate');
      });
    },
    'rateForm.exchangeRateRule' () {
      if (this.$refs.form) {
        this.$refs.form.clearValidate('exchangeRateDate');
        this.$refs.form.clearValidate('exchangeRate');
      }

      this.manualRateSyncSource = '';

      if (this.rateForm.exchangeRateRule === 'sameDayMiddleRate') {
        if (this.rateForm.targetCurrency && this.info.currency) {
          this.getRateList();
        }
        return;
      }

      this.manualRateAnchorField = '';
      this.rateForm.exchangeRate = 0;
      this.rateForm.currentReceivableAmount = '';
      this.rateForm.convertedAmount = '';
    },
    'rateForm.exchangeRateDate' () {
      if (this.rateForm.targetCurrency && this.info.currency) {
        this.getRateList();
      }
    },
    'rateForm.currentReceivableAmount' () {
      if (this.manualRateSyncSource === 'exchangeRate') {
        this.manualRateSyncSource = '';
        return;
      }

      this.manualRateAnchorField = 'currentReceivableAmount';
      this.syncManualExchangeRate();
    },
    'rateForm.exchangeRate' () {
      if (!this.rateForm.exchangeRate || Number(this.rateForm.exchangeRate) <= 0) {
        this.fluctuationExceeded = false;
        this.needFluctuationCheck = false;
        this.dataWarehouseExchangeRate = null;
      } else {
        this.refreshExchangeRateValidation();
      }

      this.validateExchangeRateFluctuation();

      if (this.manualRateSyncSource === 'currentReceivableAmount') {
        this.manualRateSyncSource = '';
        return;
      }

      if (this.isManualExchangeRateRule()) {
        this.manualRateAnchorField = 'exchangeRate';
        this.syncManualCurrentReceivableAmount();
        return;
      }

      this.updateConvertedAmounts();
    },
    'rateForm.bussinessEntity' () {
      let value = ['福建锐捷'];
      // 如果业务实体不包含在value中，并且汇率规则为sameDayMiddleRate，则将汇率规则改为poAgreedRate
      if (!value.includes(this.rateForm.bussinessEntity) && this.rateForm.exchangeRateRule === 'sameDayMiddleRate') {
        this.rateForm.exchangeRateRule = 'poAgreedRate';
      }
    }
  },
  methods: {
    isManualExchangeRateRule () {
      return ['poAgreedRate', 'otherAgreedRate'].includes(this.rateForm.exchangeRateRule);
    },
    syncManualCurrentReceivableAmount () {
      if (!this.isManualExchangeRateRule()) {
        this.updateConvertedAmounts();
        return;
      }

      if (!this.rateForm.exchangeRate || Number(this.rateForm.exchangeRate) <= 0) {
        this.manualRateSyncSource = 'exchangeRate';
        this.rateForm.currentReceivableAmount = '';
        this.rateForm.convertedAmount = '';
        return;
      }

      const currentReceivableAmount = (Number(this.info.remittanceAmount || 0) / Number(this.rateForm.exchangeRate)).toFixed(2);
      this.manualRateAnchorField = 'exchangeRate';
      this.manualRateSyncSource = 'exchangeRate';
      this.rateForm.currentReceivableAmount = Number(currentReceivableAmount);
      this.rateForm.convertedAmount = currentReceivableAmount;
    },
    syncManualExchangeRate () {
      if (!this.isManualExchangeRateRule()) {
        return;
      }

      if (!this.rateForm.currentReceivableAmount || Number(this.rateForm.currentReceivableAmount) <= 0) {
        this.manualRateSyncSource = 'currentReceivableAmount';
        this.rateForm.exchangeRate = '';
        this.rateForm.convertedAmount = '';
        return;
      }

      const exchangeRate = (Number(this.info.remittanceAmount || 0) / Number(this.rateForm.currentReceivableAmount)).toFixed(4);
      this.manualRateAnchorField = 'currentReceivableAmount';
      this.manualRateSyncSource = 'currentReceivableAmount';
      this.rateForm.exchangeRate = Number(exchangeRate);
      this.rateForm.convertedAmount = Number(this.rateForm.currentReceivableAmount).toFixed(2);
    },
    syncManualExchangeRateByAnchor () {
      if (!this.isManualExchangeRateRule()) {
        this.updateConvertedAmounts();
        return;
      }

      if (this.manualRateAnchorField === 'currentReceivableAmount') {
        this.syncManualExchangeRate();
        return;
      }

      this.syncManualCurrentReceivableAmount();
    },
    refreshExchangeRateValidation () {
      if (!this.$refs.form) {
        return;
      }

      this.$nextTick(() => {
        this.$refs.form.clearValidate('exchangeRate');
      });
    },
    validateExchangeRateFluctuation () {
      if ((this.rateForm.crossCurrencyFlag !== '1' && this.rateForm.crossCurrencyFlag !== 1) || !this.rateForm.exchangeRate || Number(this.rateForm.exchangeRate) <= 0) {
        return;
      }

      const exchangeRateDate = this.rateForm.exchangeRateDate || this.getDayRange().startDate.split(' ')[0];

      getCheckExchangeRateFluctuation({
        importAccount: this.info.importAccount,
        exchangeRateDate,
        targetCurrency: this.rateForm.targetCurrency,
        exchangeRate: this.rateForm.exchangeRate,
        exchangeRateRule: this.rateForm.exchangeRateRule
      }).then((res) => {
        const json = res.data;
        if (json.status === '200') {
          this.fluctuationExceeded = json.data.fluctuationExceeded;
          this.needFluctuationCheck = json.data.needFluctuationCheck;
          this.dataWarehouseExchangeRate = json.data.dataWarehouseExchangeRate;
        } else {
          this.$message.warning(json.err || json.message || json.error || json.msg || '汇率值校验失败');
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    updateConvertedAmounts () {
      if (!this.rateForm.exchangeRate || Number(this.rateForm.exchangeRate) <= 0) {
        this.rateForm.convertedAmount = '';
        this.rateForm.currentReceivableAmount = '';
        return;
      }

      this.rateForm.convertedAmount = (this.info.remittanceAmount / this.rateForm.exchangeRate).toFixed(2); // 转换金额 = 付款金额 * 汇率值
      this.rateForm.currentReceivableAmount = this.rateForm.convertedAmount; // 本次应收金额 = 转换金额
    },
    resetLocalState () {
      this.info = {};
      this.receiptAccount = '';
      this.receiptCurrency = '';
      this.contractCurrency = '';
      this.contractVerifyStatusList = [];
      this.loadedRowId = '';
      this.nums = '';
      this.fluctuationExceeded = false;
      this.needFluctuationCheck = false;
      this.dataWarehouseExchangeRate = null;
      this.rateForm = createDefaultRateForm();
      this.fileListBase = [];
      this.tableDataBase = [];
      this.manualRateSyncSource = '';
      this.manualRateAnchorField = '';
    },
    tryLoadDetail () {
      if (!this.rowId || this.loadedRowId === this.rowId) {
        return;
      }

      this.loadedRowId = this.rowId;
      this.loadDetail();
    },
    loadDetail () {
      listWaterOrderAttachment(this.rowId).then((res) => {
        const json = res.data;
        if (json.status === '200') {
          this.info = json.data;
          if (!Array.isArray(this.info.telegraphicContractRelationList) || !this.info.telegraphicContractRelationList.length) {
            this.$set(this.info, 'telegraphicContractRelationList', [createDefaultRelationItem()]);
            this.contractVerifyStatusList = [createDefaultContractVerifyStatus()];
          } else {
            this.info.telegraphicContractRelationList = this.info.telegraphicContractRelationList.map(item => ({
              ...createDefaultRelationItem(),
              ...item
            }));
            this.contractVerifyStatusList = this.info.telegraphicContractRelationList.map(item => ({
              status: item.cotractNum ? CONTRACT_VERIFY_STATUS.SUCCESS : CONTRACT_VERIFY_STATUS.INITIAL,
              contractCustomerName: ''
            }));
          }
          this.getContractCurrency();
          this.fileListBase = json.data.attachmentList || [];
          this.tableDataBase = json.data.intelContractAssignList || [];
        }
      }).catch((err) => {
        this.loadedRowId = '';
        console.log(err);
      });
    },
    // 获取合同币种
    async getContractCurrency () {
      let params = {
        contractNum: this.info.cotractNum
      };
      getOrderUnitAndCurrencyByContractNum(params).then((res) => {
        const json = res.data;
        if (json.status === '200') {
          this.contractCurrency = json.data.currencyId || ''; // 合同币种
          if (this.contractCurrency && this.receiptCurrency) {
            this.rateForm.crossCurrencyFlag = this.contractCurrency !== this.receiptCurrency ? '1' : '0'; // 是否跨币种
          }
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    contract () {
      if (!Array.isArray(this.info.telegraphicContractRelationList)) {
        this.$set(this.info, 'telegraphicContractRelationList', []);
      }
      this.info.telegraphicContractRelationList.push(createDefaultRelationItem());
      this.contractVerifyStatusList.push(createDefaultContractVerifyStatus());
    },
    buttonyichu (index) {
      if (!Array.isArray(this.info.telegraphicContractRelationList)) {
        return;
      }
      this.info.telegraphicContractRelationList.splice(index, 1);
      this.contractVerifyStatusList.splice(index, 1);
    },
    handleContractInput (index) {
      if (index < 0) {
        return;
      }

      this.setContractVerifyStatus(index);
    },
    getContractVerifyStatus (index) {
      const verifyStatus = this.contractVerifyStatusList[index];

      if (verifyStatus && typeof verifyStatus === 'object') {
        return {
          status: verifyStatus.status || CONTRACT_VERIFY_STATUS.INITIAL,
          contractCustomerName: verifyStatus.contractCustomerName || ''
        };
      }

      return {
        status: verifyStatus || CONTRACT_VERIFY_STATUS.INITIAL,
        contractCustomerName: ''
      };
    },
    setContractVerifyStatus (index, status = CONTRACT_VERIFY_STATUS.INITIAL, contractCustomerName = '') {
      if (index < 0) {
        return;
      }

      this.$set(this.contractVerifyStatusList, index, {
        status,
        contractCustomerName
      });
    },
    buildContractVerifyErrorMessage (contractCustomerName = '') {
      const currentCustomerName = this.info.orderUnit || '';

      if (contractCustomerName) {
        return `该合同客户名称为“${contractCustomerName}”`;
      }

      return `合同客户与汇款单客户名称“${currentCustomerName}”不一致`;
    },
    getContractVerifyError (index) {
      const { status, contractCustomerName } = this.getContractVerifyStatus(index);

      if (status === CONTRACT_VERIFY_STATUS.CUSTOMER_MISMATCH) {
        return this.buildContractVerifyErrorMessage(contractCustomerName);
      }

      if (status === CONTRACT_VERIFY_STATUS.INVALID) {
        return '请输入正确的合同编号';
      }

      return '';
    },
    blursone (index) {
      const relationItem = (this.info.telegraphicContractRelationList || [])[index];
      if (!relationItem) {
        return;
      }

      relationItem.cotractNum = (relationItem.cotractNum || '').trim();
      if (relationItem.cotractNum === '') {
        this.setContractVerifyStatus(index);
        return;
      }

      verifyContractNum({
        contractNum: relationItem.cotractNum
      }).then((res) => {
        const json = res.data;
        if (json.status === '200') {
          const contractCustomerName = json.data || '';
          if (contractCustomerName !== this.info.orderUnit) {
            this.setContractVerifyStatus(index, CONTRACT_VERIFY_STATUS.CUSTOMER_MISMATCH, contractCustomerName);
            this.$message({
              message: `合同客户与汇款单客户名称不一致，请重新输入`,
              type: 'warning'
            });
          } else {
            this.setContractVerifyStatus(index, CONTRACT_VERIFY_STATUS.SUCCESS, contractCustomerName);
          }
        } else if (json.status === '7100218') {
          this.setContractVerifyStatus(index, CONTRACT_VERIFY_STATUS.INVALID);
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    // 验证关联合同列表
    validateContractRelationList () {
      const relationList = this.info.telegraphicContractRelationList || [];
      if (!relationList.length) {
        this.$message.warning('请至少添加一条关联合同');
        return false;
      }

      const hasEmptyRow = relationList.some(item => !item.cotractNum || item.splitAmount === '' || item.splitAmount === null || item.remittanceType === '');
      if (hasEmptyRow) {
        this.$message.warning('请完善关联合同信息');
        return false;
      }

      const hasEmptyLedgerNumber = relationList.some(item => item.remittanceType === 1 && !item.ledgerNumber);
      if (hasEmptyLedgerNumber) {
        this.$message.warning('赊销回款的台账不能为空');
        return false;
      }

      let splitAmountTotal = new Big(0);
      relationList.forEach((item) => {
        splitAmountTotal = splitAmountTotal.plus(item.splitAmount || 0);
      });

      const expectedAmount = this.rateForm.crossCurrencyFlag === '1'
        ? Number(this.rateForm.currentReceivableAmount || 0)
        : Number(this.info.remittanceAmount || 0);

      if (splitAmountTotal.toNumber() !== expectedAmount) {
        this.$message({
          message: `合同拆分金额之和需等于${this.rateForm.crossCurrencyFlag === '1' ? '本次应收金额' : '付款金额'}，请重新输入`,
          type: 'warning'
        });
        return false;
      }

      const invalidContractVerifyStatus = relationList.reduce((result, item, index) => {
        if (result) {
          return result;
        }

        const verifyStatus = this.getContractVerifyStatus(index);
        return verifyStatus.status !== CONTRACT_VERIFY_STATUS.SUCCESS ? verifyStatus : null;
      }, null);
      if (invalidContractVerifyStatus) {
        this.$message({
          message: '合同客户与汇款单客户名称不一致，请重新输入',
          type: 'warning'
        });
        return false;
      }

      return true;
    },
    // 验证收款单号
    verifyReceiptNumber (type = 'default') { // type: default - 默认验证，submit - 提交时验证
      this.info.telegraphicTransferNum = (this.info.telegraphicTransferNum || '').trim();
      if (this.info.telegraphicTransferNum === '' && type === 'default') {
        this.info.actualRemittanceAmount = '';
        this.nums = '';
        return Promise.resolve();
      }

      return verifyreceiptnumber({
        receiptNumber: this.info.telegraphicTransferNum,
        type: this.iswei
      }).then((res) => {
        const json = res.data;
        if (json.status === '200') {
          if (json.data.isReceipt === true) {
            this.$message.success('该收款单号已生成收款单');
            return type === 'default' ? false : Promise.reject(new Error('receiptAlreadyExists'));
          }
          this.info.actualRemittanceAmount = json.data.actualRemittanceAmount;
          this.nums = (this.info.remittanceAmount - this.info.actualRemittanceAmount).toFixed(2);
          this.receiptAccount = json.data.account;
          this.rateForm.bussinessEntity = json.data.bussinessEntity; // 业务实体
          if (type === 'default') {
            // 提交时不需要获取业务实体相关的汇入公司，账号，交易币种等列表数据
            this.receiptCurrency = json.data.currency; // 收款单币种
            this.getBusinessEntityList(json.data.bussinessEntity); // 获取业务实体相关的汇入公司，账号，交易币种等列表数据
            this.getTargetCurrencyList(json.data.bussinessEntity); // 获取目标币种数据
            if (this.contractCurrency && this.receiptCurrency) {
              this.rateForm.crossCurrencyFlag = this.contractCurrency !== this.receiptCurrency ? '1' : '0'; // 是否跨币种
            }
          }
        }
      });
    },
    // 清空收款单号相关信息
    clearReceiptRelatedInfo () {
      this.info.telegraphicTransferNum = '';
      this.info.actualRemittanceAmount = '';
      this.receiptAccount = '';
      this.receiptCurrency = '';
      this.nums = '';
      this.rateForm.crossCurrencyFlag = '0';
    },
    // 当收款单号带出的汇入公司、账号、交易币种与现有不一样时，点击确认会覆盖原先数据
    applyBusinessEntityInfo ({ importCompany = '', importAccount = '', currency = '', currencyName = '' }) {
      this.info.importCompany = importCompany;
      this.info.importAccount = importAccount;
      this.info.currency = currency;
      this.info.currencyName = currencyName;
    },
    confirmBusinessEntityOverride (nextInfo) {
      return this.$confirm(
        '当前收款单号带出的汇入公司、账号与现有不一样，点击确认会覆盖原先数据。',
        '提示',
        {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(() => {
        this.applyBusinessEntityInfo(nextInfo);
        if (this.rateForm.targetCurrency && this.info.currency) {
          this.getRateList(); // 获取汇率数据
        }
      }).catch(() => {
        this.clearReceiptRelatedInfo();
        return Promise.reject(new Error('receiptInfoChangeCancelled'));
      });
    },
    // 获取指定日期的起始和结束时间，默认使用当天
    getDayRange (dateText = '') {
      let targetDateText = dateText;
      if (!targetDateText) {
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = `${currentDate.getMonth() + 1}`.padStart(2, '0');
        const day = `${currentDate.getDate()}`.padStart(2, '0');
        targetDateText = `${year}-${month}-${day}`;
      }

      return {
        startDate: `${targetDateText} 00:00:00`,
        endDate: `${targetDateText} 23:59:59`
      };
    },
    // 获取汇率数据
    getRateList () {
      if (!this.info.currency || !this.rateForm.targetCurrency) {
        return;
      }
      const { startDate, endDate } = this.getDayRange(this.rateForm.exchangeRateDate);
      getExchangeRate({
        pageNo: 1,
        pageSize: 100,
        inFields: {
          CONVERSION_SDATE: startDate,
          CONVERSION_EDATE: endDate,
          FROM_CURRENCY: this.rateForm.targetCurrency,
          TO_CURRENCY: this.info.currency,
          CONVERSION_TYPE: 'Corporate'
        }
      }).then((res) => {
        const json = res.data;
        if (json.status === '200') {
          if (this.rateForm.exchangeRateRule === 'sameDayMiddleRate') {
            this.rateForm.exchangeRate = json.data.data.find(item => item.TO_CURRENCY === this.info.currency && item.FROM_CURRENCY === this.rateForm.targetCurrency)?.CONVERSION_RATE || '';
            this.updateConvertedAmounts();
          }
        } else {
          this.rateForm.exchangeRate = '';
          this.$message.error('获取汇率失败，请检查币种是否正确');
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    // 当目标币种发生变化时，获取汇率数据
    handleTargetCurrencyChange () {
      this.rateForm.targetCurrencyName = this.targetCurrencyList.find(item => item.currency === this.rateForm.targetCurrency)?.currencyName || '';
      if (this.rateForm.targetCurrency && this.info.currency) {
        this.getRateList();
      }
    },
    // 获取目标币种数据
    getTargetCurrencyList (businessEntity = '') {
      let params = {
        businessEntity
      };
      getTargetCurrency(params).then((res) => {
        const json = res.data;
        if (json.status === '200') {
          this.targetCurrencyList = json.data || []; // 目标币种列表
          if (this.targetCurrencyList.length === 1) {
            this.rateForm.targetCurrency = this.targetCurrencyList[0].currency; // 默认选中第一个目标币种
            this.rateForm.targetCurrencyName = this.targetCurrencyList[0].currencyName || ''; // 默认选中第一个目标币种名称
            if (this.info.currency) {
              this.getRateList();
            }
            this.$nextTick(() => {
              this.$refs.form && this.$refs.form.clearValidate('targetCurrency');
            });
          }
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    // 根据业务实体获取汇入公司，账号，交易币种等列表数据
    getBusinessEntityList (businessEntity = '') {
      const params = {
        businessEntity
      };
      return getCompanyAndBankByBusinessEntity(params).then((res) => {
        const json = res.data;
        if (json.status === '200') {
          const businessEntityList = json.data.companyList || []; // 业务实体列表

          let companyList = {}; // 用于存储匹配的汇入公司信息
          businessEntityList.forEach(item => {
            item.accountList.forEach(account => {
              if (account.accountNo === this.receiptAccount) {
                companyList = item;
              }
            });
          });

          if (businessEntity && Object.keys(companyList).length > 0) { // 如果有业务实体，默认选中第一个汇入公司
            const accountList = companyList.accountList || [];
            const matchedAccount = accountList.find(item => item.accountNo === this.receiptAccount) || {};
            const nextInfo = {
              importCompany: companyList.companyName || '', // 汇入公司, 默认选中第一个
              importAccount: matchedAccount.accountNo || '', // 汇入账号
              currency: matchedAccount.currencyCode || '', // 交易币种
              currencyName: matchedAccount.currencyName || '' // 交易币种名称
            };
            const hasChanged = nextInfo.importCompany !== (this.info.importCompany || '') ||
              nextInfo.importAccount !== (this.info.importAccount || '') ||
              nextInfo.currency !== (this.info.currency || '') ||
              nextInfo.currencyName !== (this.info.currencyName || '');
            if (hasChanged) {
              return this.confirmBusinessEntityOverride(nextInfo);
            } else {
              if (this.rateForm.targetCurrency && this.info.currency) {
                this.getRateList(); // 获取汇率数据
              }
            }
          }
        }
      }).catch((err) => {
        if (err && err.message === 'receiptInfoChangeCancelled') {
          return Promise.reject(err);
        }
        console.log(err);
        return Promise.reject(err);
      });
    },
    handleClose () {
      this.$emit('close');
    },
    handleCancel () {
      this.$emit('update:visible', false);
      this.$emit('close');
    },
    // 提交
    handleSubmit () {
      this.submitLoading = true;
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          if (this.info.actualRemittanceAmount > this.info.remittanceAmount) {
            this.$message({
              message: '实际到款金额应小于等于付款金额，请重新输入',
              type: 'warning'
            });
            this.submitLoading = false;
            return;
          }
          if (!this.validateContractRelationList()) {
            this.submitLoading = false;
            return;
          }
          // 国际商务录入电汇单：提交前出口合规预检
          const complianceDecision = await checkIntlExportCompliance(this,
            buildIntlTelegraphicTransferComplianceRequest(this.info));
          if (!complianceDecision.allowBusiness) {
            this.submitLoading = false;
            return;
          }
          let params = {
            ...this.info,
            ...this.rateForm
          };
          if (this.rateForm.crossCurrencyFlag === '1' || this.rateForm.crossCurrencyFlag === 1) {
            const actualRemittanceAmount = Number(this.info.actualRemittanceAmount || 0);
            const exchangeRate = Number(this.rateForm.exchangeRate || 0);
            const convertedActualRemittanceAmount = exchangeRate > 0 ? (actualRemittanceAmount / exchangeRate).toFixed(2) : '';
            params.convertedActualRemittanceAmount = convertedActualRemittanceAmount;
            params.convertedServiceFee = (Number(this.rateForm.currentReceivableAmount || 0) - Number(convertedActualRemittanceAmount || 0)).toFixed(2);
            this.targetCurrencyList.forEach((item) => {
              if (item.currency === this.rateForm.targetCurrency) {
                params.virtualBankAccount = item.virtualBankAccount;
                params.virtualBankAccountName = item.virtualBankName;
              }
            });
          }
          const submitRequest = this.info.telegraphicTransferNum !== ''
            ? this.verifyReceiptNumber('submit').then(() => {
              if (this.verifyAccountMismatch()) {
                return Promise.reject(new Error('error'));
              }
              return addTelegraphicTransferInternationBusiness(params);
            })
            : addTelegraphicTransferInternationBusiness(params);

          submitRequest.then((res) => {
            const json = res.data;
            if (json.status === '200') {
              this.$message.success('提交成功');
              this.$emit('update:visible', false);
              this.$emit('success');
            }
          }).catch((err) => {
            if (err && err.message === 'error') {
              this.$message.warning('收款单汇入账号与所选汇入账号不一致');
              return;
            }
            if (err && err.message === 'receiptAlreadyExists') {
              return;
            }
            if (err) {
              console.log(err);
            }
          }).finally(() => {
            this.submitLoading = false;
          });
        } else {
          this.submitLoading = false;
          return;
        };
      });
    },
    handleBlur () {
      this.verifyReceiptNumber().catch((err) => {
        if (err && err.message === 'receiptInfoChangeCancelled') {
          return;
        }
        console.log(err);
      });
    },
    verifyAccountMismatch () {
      if (!this.info.telegraphicTransferNum) {
        return false;
      }

      return Boolean(this.receiptAccount) && this.rateForm.bussinessEntity !== '福建锐捷' && this.receiptAccount !== this.info.importAccount;
    },
    handleDownload (row) {
      if (row.cloudAddress === '1') {
        getAliOSSDownloadInfo(row.fileToken).then(({ status, data }) => {
          if (status === 200) {
            downloadBlobFile({ content: data, fileName: row.fileName });
          }
        });
        return;
      }

      const href = this.downFileUrl + `/${row.fileToken}?Token=${this.token}`;
      window.open(href, '_blank');
    }
  }
};
</script>

<style scoped>
  .footer-btn{
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
  }
  .exchange-rate-tip {
    position: absolute;
    font-size: 12px;
    color: #f59e0b;
  }
  .required{
    color: red;
    margin-left: 3px;
  }
  .rj-row-title {
    font-size: 16px;
    font-weight: bold;
    width: 100%;
    text-align: center;
    margin-top: 20px;
    margin-bottom: 10px;
  }

  .related-contract-title {
    clear: both;
    display: block;
  }
  .related-contract-actions {
    display: flex;
    align-items: center;
    width: 100%;
    clear: both;
    margin-bottom: 10px;
  }

  .related-contract-tip {
    margin-left: 12px;
    color: #b2b7c2;
    font-size: 12px;
    line-height: 1;
  }
  .cotractNum_item /deep/ .el-form-item__error {
    position: static;
  }
</style>
